import React from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
// import trashIcon from '../../assets/icons/trash.svg';

function HistoryItem({
  title, price,
}) {
  const { translations } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  return (
    <div className="history-item">
      <div className="history-item-top">
        <div className="history-item-top-info">
          <p className="history-item-top-info-title">{title}</p>
          <p className="history-item-top-info-price">
            {price}
            {' '}
            {translations.amd[lang]}
          </p>
        </div>
        {/* <div className="history-item-top-action"> */}
        {/*  <img src={trashIcon} alt="" /> */}
        {/* </div> */}
      </div>
      {/* <div className="history-item-line" /> */}
      {/* <div className="history-item-info"> */}
      {/* <div className="history-item-info-item"> */}
      {/*  <p className="history-item-info-item-title">{translations.branch[lang]}</p> */}
      {/*  <p className="history-item-info-item-value">{branch}</p> */}
      {/* </div> */}
      {/* <div className="history-item-info-item"> */}
      {/*  <p className="history-item-info-item-title">{translations.date[lang]}</p> */}
      {/*  <p className="history-item-info-item-value">{date}</p> */}
      {/* </div> */}
      {/* <div className="history-item-info-item"> */}
      {/*  <p className="history-item-info-item-title">{translations.received_bonus[lang]}</p> */}
      {/*  <p className="history-item-info-item-value">{bonus}</p> */}
      {/* </div> */}
      {/* <div className="history-item-info-item"> */}
      {/*  <p className="history-item-info-item-title">{translations.status[lang]}</p> */}
      {/*  <p className={`history-item-info-item-value
        status ${status === 'Successful' ? 'done' : 'pending'}`}>{status}</p> */}
      {/* </div> */}
      {/* <div className="history-item-info-item"> */}
      {/*  <p className="history-item-info-item-title">{translations.doctor[lang]}</p> */}
      {/*  <p className="history-item-info-item-value">{doctor}</p> */}
      {/* </div> */}
      {/* </div> */}
    </div>
  );
}

export default HistoryItem;
